<template>
  <div class="area-content">
    <!-- 片区   -->
    <div class="area-content">
      <div class="area-content-box">
        <el-tabs :stretch="true" v-model="tabPosition">
          <el-tab-pane label="全部">
            <list-main :editId="editId" :outerId="null"></list-main>
          </el-tab-pane>
          <el-tab-pane
            v-for="(item, index) in areaListData"
            :key="index"
            :label="item.name"
          >
            <div class="airport-content" v-if="item.id != '-1'">
              <!-- {{item.name}} -->
              <div class="keynote-content-main">
                <p
                  class="keynote-main keynote-main2"
                  @click="
                    title = item.name;
                    content = item.content;
                    dialogVisible = true;
                  "
                >
                  {{ item.content }}
                </p>
              </div>
              <el-carousel height="189px" class="keynote-main-img">
                <el-carousel-item
                  v-for="(item, index) in item.imgUrl"
                  :key="index"
                >
                  <img
                    style="width: 100%; height: 100%; object-fit: cover"
                    :src="imgUrl + item.filePath"
                    alt=""
                  />
                </el-carousel-item>
              </el-carousel>
            </div>
            <list-main :editId="editId" :outerId="item.id"></list-main>

            <!-- <list-main :itemArea="{ ...item }"></list-main> -->
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="35%"
      :before-close="handleClose"
    >
      <div
        style="max-height: 600px; overflow: auto; letter-spacing: 4px"
        class="scrollbar-definition"
      >
        {{ content }}
      </div>
    </el-dialog>
  </div>
</template>

<script>
import listMain from "@/components/centralYunnan/listMain.vue";

export default {
  name: "areaMain",
  props: ["listArea", "editId"],
  components: {
    listMain,
  },
  data() {
    return {
      areaData: [],
      tabPosition: "",
      areaListData: [],
      dialogVisible: false,
      title: "",
      content: "",
      imgUrl: systemConfig.imgServer + systemConfig.imgApi,
    };
  },

  // 片区数据啦!
  watch: {
    listArea: {
      handler(newVal) {
        if (!!newVal) {
          // this.areaData = []
          this.areaListData = newVal;
          this.areaListData = [...this.areaListData];

          // console.log(this.areaListData);
          // this.areaListData.forEach((item) => {
          //   this.areaData.push(item.name)
          //   this.tabPosition = this.areaData[0].item.name
          // })
        }
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    // console.log(this.listArea);
  },
  mounted() {},
  methods: {
    changeTheme(val) {
      // console.log(val);
    },
    handleClose() {
      this.dialogVisible = false;
    },
  },
};
</script>

<style scoped>
p {
  padding: 0;
  margin: 0;
}
.area-content {
  width: 100%;
  margin: auto;
  background: #ffffff;
}
.area-content-box {
  width: 60%;
  margin: 0 auto;
  padding: 20px 0;
}
.radio_el_owner {
  width: 100%;
  margin-top: 30px;
}
/deep/ .el-radio-button {
  width: calc(100% / 3) !important;
}
/*单选按钮 item 的样式*/
/deep/ .el-radio-button__inner {
  width: 100%;
  background: #f3f7ff;
  border-color: #386ed6;
  padding: 10px 0;
}
/*单选按钮 选中的样式*/
.el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background: #386ed6;
  border-color: #386ed6;
}
.airport-content {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
  /*width: 60%;*/
  margin: 0 auto auto;
  background: #f3f3f3;
  border-radius: 4px;
}
.keynote-content-main {
  height: 100%;
  width: calc(100% / 3 * 2);
}
.keynote-main-img {
  width: calc(100% / 3 - 10px);
  height: 100%;
  margin-left: 20px;
  /*background: linear-gradient(160deg, rgba(63,77,201,.8), rgba(102,180,213,.4));*/
  /*background-image: url("~@/assets/promotion/empty.png");*/
  background-size: 100% 100%;
}
.keynote-main {
  padding: 14px 20px 0 20px;
  line-height: 30px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  cursor: pointer;
}
.keynote-main2 {
  -webkit-line-clamp: 5;
  margin-top: 10px;
}
/deep/ .el-tabs__nav-scroll {
  /*overflow: visible!important;*/
}
/deep/ .el-tabs__item {
  background: #f3f7ff;
  border: 1px solid #dcdfe6;
  border-left: none;
}
/deep/ .el-tabs__item:nth-child(2) {
  border-left: 1px solid #dcdfe6;
  border-top-left-radius: 10px !important;
  border-bottom-left-radius: 10px !important;
  padding: 0 20px 0 15px !important;
}
/deep/ .el-tabs__item:last-child {
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  padding: 0 15px 0 20px !important;
}
/deep/ .el-tabs__item.is-active {
  background: #0b34b7;
  color: #ffffff;
}
/deep/ .el-tabs__active-bar {
  height: 0;
}
/deep/ .el-tabs__nav-wrap::after {
  height: 0;
}
::v-deep .el-dialog__body {
  padding: 10px 20px 30px;
}
</style>
